<c-modal #checkInDetailModal backdrop="static" size="lg" visible='true' id="checkInDetailModal">
  <c-modal-header>
      <h4 class="modal-title">{{ title }}</h4>
      <button type="button" [cModalToggle]="checkInDetailModal.id" cButtonClose (click)="closeModal()" title="Close"></button>
  </c-modal-header>
  <c-modal-body>
      <c-row>
        <form cForm class="row g-12" [formGroup]="checkInDetailForm">
          <c-row>
            <c-col>
              <c-card class="mb-4">
                <c-card-header>{{ "Branch & Date" | translate }}</c-card-header>
                <c-card-body>
                  <c-row [xs]="1" [xl]="2">
                    <c-col>
                      <c-row>
                        <label cLabel="col" cCol [sm]="12" for="branch">
                          {{ "Branch Name" | translate }}
                        </label>
                        <c-col [sm]="12" *ngIf="isBranchesLoaded && branchesList.length>0">
                            <select cFormControl formControlName="branch" aria-label="Please select a branch" cSelect>
                              <option *ngFor="let branch of branchesList" [ngValue]="branch">{{branch.name}}</option>
                            </select>
                        </c-col>
                      </c-row>
                      <c-row *ngIf="selectedBranch">
                        <label cLabel="col" cCol [sm]="12">
                          Address: {{selectedBranch.address}}
                          <br />Phone: {{selectedBranch.phone}}
                        </label>
                      </c-row>
                    </c-col>
                    <c-col [md]="12">
                      <label cLabel for="date">Date</label>
                      <input cFormControl id="date" type="date" formControlName="date" />
                    </c-col>
                  </c-row>
                </c-card-body>
              </c-card>
            </c-col>
          </c-row>
          <!-- Pet -->
          <c-row>
            <c-col>
              <c-card class="mb-4">
                <c-card-header>{{ "Pet" | translate }}</c-card-header>
                <c-card-body>
                  <c-row [xs]="1" [xl]="2">
                    <c-col>
                      <c-row>
                        <label cLabel="col" cCol [sm]="12" for="pet">
                          Pet
                        </label>
                        <c-col [sm]="12">
                          <c-input-group>
                            <input
                              formControlName="pet" name="pet" type="text" id="pet"
                              cFormControl
                              placeholder="Select pet"
                              [typeaheadOptionsLimit]="10"
                              [typeaheadLatinize]="true"
                              [typeahead]="availablePets"
                              typeaheadOptionField="name"
                              [typeaheadMinLength]="0"
                              (typeaheadOnSelect)="onSelectPet($event)"
                            />
                            <button cButton color="secondary" type="button" variant="outline">
                              Change
                            </button>
                          </c-input-group>
                        </c-col>
                      </c-row>
                    </c-col>
                  </c-row>
                  <c-row>
                    <c-col class="col-md-6 mt-2" *ngFor="let pet of selectedPets; let i = index" cTooltip="Click to show details">
                      <c-card class="mb-4 position-relative">
                        <c-card-header>
                          {{ pet.name }}
                          <div *ngIf="hasEditPermission || hasAddPermission" class="position-absolute top-0 end-0">
                            <i class="fa fa-trash text-warning mr-2" (click)="deleteSelectedPet(pet)"></i>
                          </div>
                        </c-card-header>
                        <c-card-body>
                          <p class="card-text">
                            Sex: {{ pet.sex }}<br />
                            Age: {{ pet.age }}<br />
                            Owner: {{pet.owner.firstName}} {{pet.owner.lastName}}<br />
                          </p>
                        </c-card-body>
                      </c-card>
                    </c-col>
                  </c-row>
                </c-card-body>
              </c-card>
            </c-col>
          </c-row>
          <!-- <c-row>
            <c-col [xs]>
              <c-row>
                <c-col>
                  Pet
                </c-col>
                <c-col xs="12">
                  <c-col [md]="12">
                    <label cLabel for="PetName">Name</label>
                    <c-input-group>
                      <input
                        formControlName="PetName" name="PetName" type="text" id="PetName"
                        cFormControl
                        placeholder="Select Pet"
                        [typeaheadOptionsLimit]="10"
                        [typeaheadLatinize]="true"
                        [typeahead]="availablePets"
                        typeaheadOptionField="name"
                        [typeaheadMinLength]="0"
                        (typeaheadOnSelect)="onSelectPet($event)"
                      />
                      <button cButton color="secondary" type="button" variant="outline">
                        Change
                      </button>
                    </c-input-group>
                  </c-col>
                  <c-col [xs]="12" *ngIf="selectedPet?.code">
                    <label cLabel>{{selectedPet.code}}</label>
                  </c-col>
                  <c-col [xs]="12" *ngIf="selectedPet?.weight">
                    <label cLabel>{{selectedPet.weight}}</label>
                  </c-col>
                </c-col>
              </c-row>
            </c-col>
            <c-col [xs]>
              <c-row>
                <c-col>
                  Owner
                </c-col>
                <c-col [xs]="12" *ngIf="selectedPet?.owner?.firstName">
                  <label cLabel>{{selectedPet.owner.firstName}} {{selectedPet.owner.lastName}}</label>
                </c-col>
                <c-col [xs]="12" *ngIf="selectedPet?.owner?.phone">
                  <label cLabel>{{selectedPet.owner.phone}}</label>
                </c-col>
                <c-col [xs]="12"  *ngIf="selectedPet?.owner?.email">
                  <label cLabel>{{selectedPet.owner.email}}</label>
                </c-col>
                <c-col [xs]="12"  *ngIf="selectedPet?.owner?.type?.name">
                  <label cLabel>{{selectedPet.owner.type.name}}</label>
                </c-col>
              </c-row>
            </c-col>
          </c-row> -->

          <c-row>
            <c-col>
              <c-card class="mb-4">
                <c-card-header>Requested Services</c-card-header>
                <c-card-body>
                  <c-row [xs]="1" [xl]="2">
                    <c-col>
                      <c-row>
                        <label cLabel="col" cCol [sm]="12">
                          Available Services
                        </label>
                        <c-col [sm]="12">
                          <c-input-group>
                            <input aria-label="service"
                              placeholder="Add service"
                              formControlName="service" name="service" type="text" id="service"
                              cFormControl
                              placeholder="Add service"
                              [typeaheadOptionsLimit]="10"
                              [typeaheadLatinize]="true"
                              [typeahead]="availableServices"
                              typeaheadOptionField="name"
                              [typeaheadMinLength]="0"
                              (typeaheadOnSelect)="onSelectService($event)"
                            />
                            <button cButton color="secondary" type="button" variant="outline">
                              Add
                            </button>
                          </c-input-group>
                        </c-col>
                      </c-row>

                    </c-col>
                    <c-col>
                      <c-row>
                        <label cLabel="col" cCol [sm]="12">
                          Selected Services
                        </label>
                      </c-row>
                      <c-row *ngIf="selectedServices.length>0">
                        <ul cListGroup *ngFor="let service of selectedServices">
                          <li cListGroupItem><span *ngIf="hasEditPermission || hasAddPermission" class="fa fa-trash" (click)="deleteService(service)"></span><span>&nbsp; {{service.name}}</span></li>
                        </ul>
                      </c-row>

                    </c-col>
                  </c-row>
                </c-card-body>
              </c-card>
            </c-col>
          </c-row>

          <c-row>
            <c-col [xs]>
              <c-row>
                <c-col>
                  Services
                </c-col>
                <c-col [md]="12">
                  <!-- <c-input-group>
                    <input aria-label="service"
                      placeholder="Add service"
                      formControlName="serviceName" name="serviceName" type="text" id="serviceName"
                      cFormControl
                      placeholder="Add serviceName"
                      [typeaheadOptionsLimit]="10"
                      [typeaheadLatinize]="true"
                      [typeahead]="availableServices"
                      typeaheadOptionField="name"
                      [typeaheadMinLength]="0"
                      (typeaheadOnSelect)="onSelectService($event)"
                    />
                    <button cButton color="secondary" type="button" variant="outline">
                      Add
                    </button>
                  </c-input-group> -->
                </c-col>
                <c-col [xs]="12">
                  <!-- <ul cListGroup *ngFor="let service of selectedServices">
                    <li cListGroupItem><span class="fa fa-trash" (click)="deleteService(service)"></span><span>&nbsp; {{service.name}}</span></li>
                  </ul> -->
                </c-col>
              </c-row>
            </c-col>
          </c-row>
        </form>
      </c-row>
  </c-modal-body>
  <c-modal-footer>
    <button cButton color="secondary" (click)="closeModal()">Close</button>
    <button *ngIf="(!isNew && hasEditPermission) || (isNew && hasAddPermission)" cButton color="primary" (click)="saveCheckInDetail()">Submit</button>
    <button *ngIf="!isNew && hasEditPermission" cButton color="info" (click)="createCheckOut()" [disabled]="isCheckedOut"><i class="fas fa-spinner fa-spin" [hidden]="!isCreatingCheckOut"></i>Check Out</button>
  </c-modal-footer>
</c-modal>
